// fetchApprovalCounts.js - API functions for getting approval counts

const API_URL = process.env.REACT_APP_API_URL || 'https://localhost:7204';

// Get approval count for a specific event
export const getApprovalCount = async (buildingId, eventName, dateTime) => {
    try {
        const params = new URLSearchParams({
            buildingId: buildingId.toString(),
            eventName: eventName,
            dateTime: dateTime
        });

        const response = await fetch(`${API_URL}/api/Approvers/GetApprovalCount?${params}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(errorText || `HTTP error! status: ${response.status}`);
        }

        return await response.json();
    } catch (err) {
        throw err;
    }
};

// Get all events with their approval counts for a building
export const getEventsWithApprovalCounts = async (buildingId) => {
    try {
        const response = await fetch(`${API_URL}/api/Approvers/GetEventsWithApprovalCounts?buildingId=${buildingId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(errorText || `HTTP error! status: ${response.status}`);
        }

        return await response.json();
    } catch (err) {
        throw err;
    }
};

// Update confirmUsersNumber field in Event table
export const updateEventApprovalCount = async (buildingId, eventName, dateTime, date, time) => {
    try {
        const response = await fetch(`${API_URL}/api/Approvers/UpdateEventApprovalCount`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify({
                BuildingId: parseInt(buildingId),
                EventName: eventName,
                DateTime: dateTime,
                Date: date,
                Time: time
            })
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(errorText || `HTTP error! status: ${response.status}`);
        }

        return await response.json();
    } catch (err) {
        throw err;
    }
};

// Sync all event approval counts for a building
export const syncAllEventApprovalCounts = async (buildingId) => {
    try {
        const response = await fetch(`${API_URL}/api/Approvers/SyncAllEventApprovalCounts?buildingId=${buildingId}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(errorText || `HTTP error! status: ${response.status}`);
        }

        return await response.json();
    } catch (err) {
        throw err;
    }
};